export const loadBalancerDNS = 'http://dine-align-alb-615511654.us-east-1.elb.amazonaws.com';
export const serverURL = "https://dine-align-vercel-server.vercel.app"